"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8501],{

/***/ 88501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ animated_icons_grid_component; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icons-grid-component.scss.js


var StyledAnimatedIconsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eoz99q10"
})("max-width:", "".concat(vp_sizes/* MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */.Ld, "px"), ";margin:auto;display:flex;flex-direction:column;justify-content:flex-end;.icons-container{width:100%;justify-content:center;display:flex;gap:14px;.icon-container{width:56px;height:56px;}}");

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 1 modules
var asset_component = __webpack_require__(49738);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icon/animated-icon.scss.js

var StyledAnimatedIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewndsas0"
})("opacity:0;transform:translateY(-", function(props) {
    return props.initialOffset;
}, "px);&.fall-in-animation{animation:fall-in ", function(props) {
    return props.animationDuration;
}, "s ease-in-out forwards;}}@keyframes fall-in{0%{opacity:0;}100%{opacity:1;transform:translateY(0px);}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icon/animated-icon.js




var AnimatedIcon = function(props) {
    var iconAsset = props.iconAsset, animationDuration = props.animationDuration, initialOffset = props.initialOffset, startAnimation = props.startAnimation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnimatedIcon, {
        className: classnames_default()("animated-icon", {
            "fall-in-animation": startAnimation
        }),
        animationDuration: animationDuration,
        initialOffset: initialOffset,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, {
            image: {
                src: iconAsset
            }
        })
    });
};
/* harmony default export */ var animated_icon = (AnimatedIcon);

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icons-grid-component.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var AnimatedIconsGridComponent = function(props) {
    // isInView is a prop we get from the visibility sensor in base-layout-segment-component.js
    var iconsArray = props.iconsArray, isInView = props.isInView;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnimatedIconsGridComponent, {
        className: "animated-icons-grid-component",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "icons-container",
            children: iconsArray === null || iconsArray === void 0 ? void 0 : iconsArray.map(function(icon, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(animated_icon, _object_spread_props(_object_spread({
                        iconAsset: icon === null || icon === void 0 ? void 0 : icon.iconAsset
                    }, icon), {
                        startAnimation: isInView
                    }))
                }, index);
            })
        })
    });
};
/* harmony default export */ var animated_icons_grid_component = (AnimatedIconsGridComponent);


/***/ })

}]);